import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './MarketSelector.css';

export interface Market {
  code: string;
  name: string;
  flag: string;
}

export const AVAILABLE_MARKETS: Market[] = [
  { code: 'Global', name: 'Global Market', flag: '🌍' },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'US', name: 'United States', flag: '🇺🇸' },
  { code: 'UK', name: 'United Kingdom', flag: '🇬🇧' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪' },
  { code: 'FR', name: 'France', flag: '🇫🇷' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷' },
  { code: 'IN', name: 'India', flag: '🇮🇳' },
  { code: 'CN', name: 'China', flag: '🇨🇳' }
];

interface MarketSelectorProps {
  selectedMarket: string;
  onMarketChange: (marketCode: string) => void;
  label?: string;
  disabled?: boolean;
  defaultCountry?: string; // From user's country settings
}

export const MarketSelector: React.FC<MarketSelectorProps> = ({
  selectedMarket,
  onMarketChange,
  label,
  disabled = false,
  defaultCountry
}) => {
  const { t } = useLanguage();
  const displayLabel = label || t('aiIdeaGenerator.targetMarket');
  
  return (
    <div className="market-selector">
      <label htmlFor="market-select" className="market-selector-label">
        {displayLabel}
      </label>
      <select
        id="market-select"
        className="market-selector-dropdown"
        value={selectedMarket}
        onChange={(e) => onMarketChange(e.target.value)}
        disabled={disabled}
      >
        {AVAILABLE_MARKETS.map((market) => (
          <option key={market.code} value={market.code}>
            {market.flag} {market.name}
            {defaultCountry && market.code === defaultCountry ? ` (${t('aiIdeaGenerator.yourCountry')})` : ''}
          </option>
        ))}
      </select>
      <p className="market-selector-hint">
        {t('aiIdeaGenerator.marketHint')}
      </p>
    </div>
  );
};
